module.exports = __webpack_public_path__ + "img/infoLink.77d1329d.svg";